import React, { useState, useEffect } from "react";
import { useUserAuth } from "../../context/userAuthContext";
import { db } from "../../firebase";
import {
    collection,
    getDocs,
    query,
    orderBy,
} from "firebase/firestore";
import { Loader2, Tag } from "lucide-react";

const CategoryManager = ({
    selectedCategories = [],
    onCategorySelect,
    onCategoriesLoad
}) => {
    const { user } = useUserAuth();
    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    // Fetch existing categories from vineCategories collection - sin callback en dependencies
    useEffect(() => {
        const fetchCategories = async () => {
            try {
                setLoading(true);
                // Usamos la colección "vineCategories"
                const categoriesCollection = collection(db, "vineCategories");
                const q = query(categoriesCollection, orderBy("name", "asc"));
                const categorySnapshot = await getDocs(q);

                if (categorySnapshot.empty) {
                    setCategories([]);
                    if (onCategoriesLoad) {
                        onCategoriesLoad([]);
                    }
                    setLoading(false);
                    return;
                }

                const categoryList = categorySnapshot.docs.map((doc) => ({
                    id: doc.id,
                    ...doc.data(),
                }));

                console.log("Categorías cargadas:", categoryList);

                setCategories(categoryList);

                // Notificar al componente padre que las categorías están cargadas
                if (onCategoriesLoad) {
                    onCategoriesLoad(categoryList);
                }
            } catch (error) {
                console.error("Error fetching vineCategories:", error);
                setError("Error al cargar categorías");
            } finally {
                setLoading(false);
            }
        };

        fetchCategories();
        // Eliminamos onCategoriesLoad de las dependencias para evitar el bucle infinito
    }, []);

    // Handle category selection
    const handleCategoryChange = (categoryId) => {
        if (onCategorySelect) {
            onCategorySelect(categoryId);
        }
    };

    return (
        <div>
            {error && (
                <div className="mb-3 text-sm text-red-600">{error}</div>
            )}

            <div className="flex flex-wrap items-center gap-2 mb-3">
                {loading ? (
                    <div className="flex items-center text-gray-500">
                        <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                        <span>Cargando categorías...</span>
                    </div>
                ) : categories.length > 0 ? (
                    categories.map((category) => (
                        <label
                            key={category.id}
                            className={`inline-flex items-center px-3 py-1 rounded-full text-sm font-medium cursor-pointer ${selectedCategories.includes(category.id)
                                    ? "bg-purple-100 text-purple-800 border-2 border-purple-500"
                                    : "bg-gray-100 text-gray-800 border border-gray-300 hover:bg-gray-200"
                                }`}
                        >
                            {category.iconUrl ? (
                                <img
                                    src={category.iconUrl}
                                    alt=""
                                    className="w-4 h-4 mr-1 object-contain"
                                />
                            ) : (
                                <Tag className="w-3 h-3 mr-1 text-gray-400" />
                            )}
                            <input
                                type="checkbox"
                                className="sr-only"
                                checked={selectedCategories.includes(category.id)}
                                onChange={() => handleCategoryChange(category.id)}
                            />
                            {category.name}
                        </label>
                    ))
                ) : (
                    <div className="text-gray-500 py-2">
                        No hay categorías disponibles.
                        <a href="/newCategory" className="ml-1 text-purple-600 hover:text-purple-800">
                            Crear categorías
                        </a>
                    </div>
                )}
            </div>

            {categories.length > 0 && (
                <div className="flex justify-end mt-2">
                    <a
                        href="/newCategory"
                        className="text-sm text-purple-600 hover:text-purple-800 flex items-center"
                    >
                        Administrar categorías
                    </a>
                </div>
            )}
        </div>
    );
};

export default CategoryManager;